import React from 'react'

// Simple Link component that avoids gatsby-link ES module interop issues
// When onClick is provided without to, renders as a <button> instead of navigating
// When to="#contact", opens the contact popup instead of navigating
export default function Link({ children, to, className, onClick, disabled, ...other }: any) {
    const url = to || ''

    // If there's an onClick but no URL, render as a button
    if (onClick && !url) {
        return (
            <button
                onClick={onClick}
                className={className}
                disabled={disabled}
                type="button"
            >
                {children}
            </button>
        )
    }

    // Handle #contact links - open popup instead of navigating
    if (url === '#contact') {
        return (
            <a
                href="#contact"
                className={className}
                onClick={(e) => {
                    e.preventDefault()
                    if (onClick) onClick(e)
                }}
                {...other}
            >
                {children}
            </a>
        )
    }

    const href = url || '/'
    const isExternal = href.startsWith('http') || href.startsWith('//')

    return (
        <a
            href={href}
            className={className}
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noopener noreferrer' : undefined}
            onClick={onClick}
            {...other}
        >
            {children}
        </a>
    )
}
